import { createAllActions } from '@api/createRequestStore';
import addScrollingWindow from '@utils/addScrollingWindow';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const createDashboard = (payload, unsavedId, createThenMakeDefault, makeDefaultFn) => ({
  type: types.CREATE_DASHBOARD,
  createThenMakeDefault,
  makeDefaultFn,
  payload: addScrollingWindow(payload),
  unsavedId, // unsaved dashboard id
});

export const createDashboardByDashboardType = (
  dashboardName,
  dashboard,
  dashboardType,
  tempId,
  createThenMakeDefault,
  makeDefaultFn,
) => ({
  type: types.CREATE_DASHBOARD_BY_DASHBOARD_TYPE,
  dashboardName,
  dashboard: addScrollingWindow(dashboard),
  dashboardType,
  tempId,
  createThenMakeDefault,
  makeDefaultFn,
});

const { init: initRequest, fetching } = createAllActions(types.SCOPE);

export { initRequest, fetching };
